export default (store) => {
    let onchange = () => {
        let online = navigator.onLine;
        store.commit("layout/setOnLine",online);
    }
    window.addEventListener("online", onchange);
    window.addEventListener("offline", onchange);
}